import { useCallback } from 'react';
import { PATH_AFTER_LOGIN } from '@src/config-global';

import Button from '@mui/material/Button';
import { Theme, SxProps } from '@mui/material/styles';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
  redirectTo?: string; // Optional redirect path after login
};

export default function LoginButton({ sx, redirectTo }: Props) {
  const { loginWithRedirect } = useAuthContext();

  const handleLogin = useCallback(() => {
    // If a specific redirect is provided, use it, otherwise use dashboard
    const returnTo = redirectTo || PATH_AFTER_LOGIN;

    loginWithRedirect({
      appState: {
        returnTo,
      },
    });
  }, [loginWithRedirect, redirectTo]);

  return (
    <Button onClick={handleLogin} variant="outlined" sx={{ mr: 1, ...sx }}>
      Login
    </Button>
  );
}
